var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineNoteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81 18v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H7zM7.25 5V2c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM15.25 5V2c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73 21.11c-1.18-1.33-1.37-3.32-1.41-5.09l-.13-6.17c-.1-4.73 1.47-6.7 5.57-7.01l8.04-.16h.04c4.11.14 5.75 2.04 5.85 6.78l.12 6.17c.04 1.77-.08 3.77-1.2 5.14-1.02 1.25-2.74 1.86-5.41 1.92l-6 .12h-.35c-2.47 0-4.1-.54-5.12-1.7zm4.1-16.78c-2.8.22-4.23 1.12-4.14 5.49l.13 6.17c.04 2.12.35 3.36 1.03 4.13.76.86 2.13 1.24 4.33 1.19l6-.12c2.19-.04 3.55-.48 4.28-1.37.65-.79.91-2.04.86-4.16l-.12-6.17c-.1-4.36-1.56-5.22-4.4-5.32l-7.97.16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineNoteAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-note-add.d14b4d9d50c52d52c8c6e4ed139fba02.svg";
export { ForwardRef as ReactComponent };